import styled                 from 'styled-components';

import { CloseVector        } from 'src/components/vector/close';

import { DialogVariants     } from 'src/components/common/dialog';
import { IconButtonVariants } from 'src/components/common/icon-button';

import { cssFlexColumn,
         Typo,
         themeTypos,
         typoAsCSS,
         themeColors        } from 'src/providers/theme/shared';



type CarriageHelpDialogLookAndFeel = {
  paddings: number[];
  gap: number;

  captionTypo: Typo;
  captionColor: string;

  messageTypo: Typo;
  messageColor: string;

  dialogVariant: DialogVariants;
  closeButtonVariant: IconButtonVariants;
}

const carriagehelpdialog_light: CarriageHelpDialogLookAndFeel = {
  paddings: [24],
  gap: 24,

  captionTypo: themeTypos.GRTSKREG_W400_S20_LH24,
  captionColor: themeColors.PrimaryBlack,

  messageTypo: themeTypos.GRTSKREG_W400_S14_LH20,
  messageColor: themeColors.SecondaryGray9,

  dialogVariant: 'light',
  closeButtonVariant: 's48bluered',
}

export type CarriageHelpDialogVariants = 'light';

export const carriagehelpdialog_variants: Map<CarriageHelpDialogVariants, CarriageHelpDialogLookAndFeel> = 
  new Map<CarriageHelpDialogVariants, CarriageHelpDialogLookAndFeel>([
    ['light', carriagehelpdialog_light],
  ]);

export const Container = styled.div<{
  lookAndFeel: CarriageHelpDialogLookAndFeel
}>`
  ${cssFlexColumn};
  max-height: 90vh;
  align-items: center;
  gap: ${(args) => args.lookAndFeel.gap}px;
  padding: ${(args) => args.lookAndFeel.paddings[0]}px;
  position: relative;
`

export const Caption = styled.div<{
  lookAndFeel: CarriageHelpDialogLookAndFeel
}>`
  text-align: center;

  ${(args) => typoAsCSS(args.lookAndFeel.captionTypo)};
  color: ${(args) => args.lookAndFeel.captionColor};
`

export const Message = styled.div<{
  lookAndFeel: CarriageHelpDialogLookAndFeel
}>`
  text-align: center;

  ${(args) => typoAsCSS(args.lookAndFeel.messageTypo)};
  color: ${(args) => args.lookAndFeel.messageColor};
`

export const Close = styled.div<{
  lookAndFeel: CarriageHelpDialogLookAndFeel
}>`
  position: absolute;
  top: 0;
  right: 0;
`

export const CloseOutlineVectorBig = styled(CloseVector)`
  width: 16px;
  height: 16px;
`;
